import React, { useState, useEffect, useRef } from "react";

import ReactSelect from "react-select";
import ImageUpload from "../../../components/ContentUpload/ImageUpload";
import VideoUpload from "../../../components/ContentUpload/VideoUpload";
import YoutubeInput from "../../../components/ContentUpload/YoutubeInput";
import MenuList from "../../../components/ContentUpload/MenuList";
import SingleValue from "../../../components/ContentUpload/SingleValue";
import moment from "moment";
import TimePicker from "../../../components/TimePicker";
import "./index.css";

import {
  goalTypes,
  redemptionPages,
} from "../constants/selections";
import { ContentTypes } from "../../../Constants/selections";
const initialGoalData = {
  goalType: null,
  redemptionPage: null,
  contentType: null,
  title: "",
  description: "",
  token: 100,
  scheduledDate: moment(),
};
const AddGoal = ({ selectedDate, onAdd }) => {
  const [goalData, setGoalData] = useState(initialGoalData);
  const [mediaContent, setMediaContent] = useState(null);
  const [isPostable, setIsPostable] = useState(false);
  const dismissElement = useRef();
  useEffect(() => {
    goalData["scheduledDate"] = selectedDate;
    setGoalData({ ...goalData });
  }, [selectedDate]);
  useEffect(() => {
    //find empty value inside goalData
    const isEmptyExisting =
      Object.values(goalData).filter((item) => item === "").length || false;

    //check if schedule data is after current time
    let dateValidation = true;
    let current = moment(new Date());
    if (!moment(goalData["scheduledDate"]).isAfter(current)) {
      dateValidation = false;
    }

    setIsPostable(!isEmptyExisting && mediaContent && dateValidation);
  }, [goalData, mediaContent]);
  const handleChangeSelect = ({ value, label }, property) => {
    goalData[property] = { value, label };
    setGoalData({ ...goalData });
  };
  const handleChangeInput = ({ target }) => {
    goalData[target.name] =
      target.name === "token" ? parseInt(target.value, 10) : target.value;

    setGoalData({ ...goalData });
  };
  const handleClickPost = () => {
    const {
      description,
      title,
      token,
      contentType,
      goalType,
      redemptionPage,
      scheduledDate,
    } = goalData;
    const payload = {
      title,
      description,
      token,
      scheduledDate,
      goalType: goalType.value,
      redemptionPage: redemptionPage.value,
      contentType: contentType.value,
    };
    onAdd(payload, mediaContent);
    setGoalData({ ...initialGoalData });
  };
  const handleClickClose = () => {
    setGoalData({ ...initialGoalData });
    dismissElement.current.click();
  };
  const handleChangeContent = (content) => {
    setMediaContent(content);
  };
  const onChangeTime = (obj) => {
    const scheduledDate = goalData["scheduledDate"];
    const { hh, mm, of } = obj;
    let hours = hh;
    let newMoment = moment(scheduledDate);
    if (of === "pm" && hh !== 12) hours = hh + 12;
    newMoment.set("hour", hours);
    newMoment.set("minute", mm);
    goalData["scheduledDate"] = newMoment;
    setGoalData({ ...goalData });
  };
  return (
    <div
      className="modal fade add-goal-dialog"
      id="add_goal_modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-default-fadein"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content add-goal-dialog-content">
          <div className="modal-header">
            <h5 className="modal-title">Add a community gamification goals</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              ref={dismissElement}
              onClick={handleClickClose}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body pb-1 ">
            <div className="form-group row">
              <div className="col-12">
                <ReactSelect
                  value={goalData["goalType"]}
                  onChange={(e) => handleChangeSelect(e, "goalType")}
                  options={goalTypes.map((obj) => ({
                    value: obj,
                    label: obj,
                  }))}
                  placeholder="Select the goal type"
                  isSearchable={false}
                ></ReactSelect>
              </div>
            </div>
            <div className="form-group row">
              <div className="col-12">
                <ReactSelect
                  value={goalData["redemptionPage"]}
                  onChange={(e) => handleChangeSelect(e, "redemptionPage")}
                  options={redemptionPages.map((obj) => ({
                    value: obj,
                    label: obj,
                  }))}
                  placeholder="Select redemption page"
                  isSearchable={false}
                ></ReactSelect>
              </div>
            </div>
            <div className="form-group row">
              <div className="col-12">
                <ReactSelect
                  value={goalData["contentType"]}
                  onChange={(e) => handleChangeSelect(e, "contentType")}
                  options={ContentTypes}
                  placeholder="What content would you like to post?"
                  isSearchable={false}
                  components={{ MenuList, SingleValue }}
                ></ReactSelect>
              </div>
            </div>
            {goalData["contentType"] && (
              <div className="form-group row">
                {goalData["contentType"].value === "youtube_url" && (
                  <YoutubeInput onChangeContent={handleChangeContent} />
                )}
                {goalData["contentType"].value === "image_file" && (
                  <ImageUpload onChangeContent={handleChangeContent} />
                )}
                {goalData["contentType"].value === "video_file" && (
                  <VideoUpload onChangeContent={handleChangeContent} />
                )}
              </div>
            )}
            <div className="form-group row">
              <div className="col-12">
                <input
                  type="text"
                  name="title"
                  className="form-control"
                  placeholder="Goal title"
                  value={goalData["title"]}
                  onChange={handleChangeInput}
                />
              </div>
            </div>
            <div className="form-group row">
              <div className="col-12">
                <textarea
                  className="form-control post_content "
                  name="description"
                  value={goalData["description"]}
                  placeholder="Input description here.."
                  maxLength="280"
                  onChange={handleChangeInput}
                ></textarea>
                <p className="bottom-small-text">Max characters: 280</p>
              </div>
            </div>
            <div className="form-group row">
              <div className="col-3">
                <b>Token reward</b>
                <input
                  type="number"
                  name="token"
                  value={goalData["token"]}
                  min="0"
                  className="form-control input-sm"
                  onChange={handleChangeInput}
                />
              </div>
            </div>
            <div className="schedule-container">
              <b>Schedule</b>
              {goalData["scheduledDate"] && (
                <React.Fragment>
                  <p className="schedule-time">
                    {goalData["scheduledDate"].format("LLL")}
                  </p>
                  <TimePicker onChange={onChangeTime} />
                </React.Fragment>
              )}
            </div>
          </div>
          <div className="modal-footer footer-container">
            <div className="col-12">
              <div className="btn-action-container">
                <button
                  type="button"
                  className="btn btn-green"
                  data-dismiss="modal"
                  disabled={!isPostable}
                  onClick={handleClickPost}
                >
                  Post
                </button>
                <button
                  type="button"
                  className="btn btn-orange"
                  onClick={handleClickClose}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddGoal;



// WEBPACK FOOTER //
// ./src/screens/GamificationGoals/components/AddGoal.js